exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___2ja8_{display:grid;gap:1.5rem}@media screen and (min-width:1325px){.index-module__wrapper___2ja8_{grid-template-columns:300px auto}}@media screen and (min-width:1600px){.index-module__wrapper___2ja8_{grid-template-columns:330px auto}}.index-module__wrapper___2ja8_.index-module__school___2Hdf9{grid-template-columns:1fr}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___2ja8_",
	"school": "index-module__school___2Hdf9"
};